module.exports = __webpack_public_path__ + "static/media/coreValues-04.f626ffe3.svg";